<template>
  <div
    class="fixed bottom-0 h-12 border-t-oekoprofitgruen w-full border-t-4 bg-white shadow-lg flex justify-between sm:justify-end sm:space-x-12 items-center px-8"
  >
    <div class="flex-grow flex space-x-2">
      <div v-if="Datenjahr.DatenjahrIsSet.value">
        <router-link to="/teilnahmen">
          <span 
            class="border rounded-md px-2 py-1 cursor-pointer truncate"
            :class="[
              false ? 'bg-oekoprofitgruen' : ''
            ]"
          >
            <strong>Programm:</strong>
            {{ Datenjahr.Teilnahme.value?.programm?.name ?? "Kein Programm gewählt" }}
          </span>
          <span 
            class="border rounded-md px-2 py-1 cursor-pointer truncate"
            :class="[
              false ? 'bg-oekoprofitgruen' : ''
            ]"
          >
            <strong>Datenjahr:</strong>
            {{ Datenjahr.Datenjahr.value ?? "Kein Datenjahr ausgewählt" }}
          </span>
        </router-link>
      </div>
    </div>
      <router-link to="/Netzwerksuche" v-if="Identity.IsAuthenticated && false">
        <span class="border rounded-md px-2 py-1 cursor-pointer">
          <strong>Netzwerk</strong>
        </span>
      </router-link>
      <router-link to="/Login" v-else>
        <span class="border rounded-md px-2 py-1 cursor-pointer">
          <strong>Login</strong>
        </span>
      </router-link>
      <router-link v-if="Identity.IsAuthenticated" to="/Impressum">IMPRESSUM</router-link>
      <router-link v-if="Identity.IsAuthenticated" to="/Datenschutz">DATENSCHUTZ</router-link>
    </div>
</template>

<script lang="ts" setup>
import { useServices } from "../services";
import { useIdentity } from "../features/identity";

const { Identity } = useIdentity();
const { Datenjahr } = useServices();


</script>
